import { TagIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'
import { SALE_CONFIG } from '@/saleConfig'

export const MagicShopLinks = () => {
  return (
    <div>
      <h2 className="text-vi-gray border-y-2 border-vi-gray text-xl font-bold p-2 pb-1 hover:bg-gray-100">
        <Link href="/magic-tricks">
          <TagIcon className="w-8 h-8 inline-block mb-1" /> Magic Shop
        </Link>
      </h2>
      <ul>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/search/" className="text-vi-red block">
            Instant product search
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/magic-tricks/" className="text-vi-red block">
            New magic tricks
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/easy-magic-tricks/" className="text-vi-red block">
            Easy magic tricks
          </Link>
        </li>
        {SALE_CONFIG.saleActive && (
          <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
            <Link href="/sale/" className="text-vi-red block">
              Discounted magic
            </Link>
          </li>
        )}
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/card-magic/" className="text-vi-red block">
            Card magic
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/close-up-magic/" className="text-vi-red block">
            Close-up Magic
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/mentalism/" className="text-vi-red block">
            Mentalism
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/props/" className="text-vi-red block">
            Magic prop store
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/playing-cards/" className="text-vi-red block">
            Playing cards
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/magic-books/" className="text-vi-red block">
            Magic books
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/magic-dvds/" className="text-vi-red block">
            Magic DVDs
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link href="/amazekids/" className="text-vi-red block">
            Magic for kids entertainers
          </Link>
        </li>
      </ul>
    </div>
  )
}
